<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('edit-vital-entry-header') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>

		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 221px)">
			<v-row dense class="ma-0">
				<v-col cols="6">
					<v-text-field :label="$t('value')" v-model="vitalValue" outlined hide-details />
				</v-col>
				<v-col cols="6">
					<v-select
						:label="$t('unit')"
						v-model="selectedUnit"
						:items="availableUnits"
						item-text="unit"
						outlined
						hide-details
						:menu-props="{ maxHeight: 150, offsetY: true }">
						<template v-slot:item="{ item }">
							{{ item.unit }}
						</template>
					</v-select>
				</v-col>
			</v-row>

			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-textarea v-model="notes" :label="$t('note')" outlined no-resize hide-details rows="12" />
				</v-col>
			</v-row>
		</v-card-text>

		<v-container class="px-4">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<InputTimeFormatter
						:inputValue="timeSpentSeconds"
						@update:inputValue="(val) => (timeSpentSeconds = val)"
						:inputLabel="$t('time-spent')"
						:dense="false" />
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="6" order="1">
					<v-btn @click="closeDrawer()" color="secondary" style="color: black" block>
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-tooltip top v-if="!editButtonEnabled">
					<template v-slot:activator="{ on, attrs }">
						<v-col cols="6" v-bind="attrs" v-on="on" order="2">
							<v-btn disabled block>{{ $t('update') }}</v-btn>
						</v-col>
					</template>
					<span>{{ $t('fill-all-fields-warning') }}</span>
				</v-tooltip>
				<v-col cols="6" v-else order="2">
					<v-btn @click="updateVitalEntry()" color="dark_purple" style="color: white" block>
						{{ $t('update') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import InputTimeFormatter from '../Client/components/InputTimeFormatter.vue';

export default {
	name: 'CCMVitalEntryEdit',
	data () {
		return {
			notes: '',
			vitalValue: null,
			selectedUnit: '',
			availableUnits: [],
			selectedType: null,
			timeSpentSeconds: 0,
			unitOptions: null,
		};
	},
	computed: {
		...mapState({
			selectedVitalEntry: (state) => state.ccmVitalEntry.ccmVitalEntry,
		}),
		editButtonEnabled () {
			return this.notes.trim() && this.vitalValue && this.timeSpentSeconds && this.timeSpentSeconds <= 7200;
		},
	},
	components: { InputTimeFormatter },
	methods: {
		...mapActions({
			getAllVitalTypeOptions: 'ccmRecords/getVitalTypeOptionTemplate',
			getAllVitalUnitOptions: 'ccmRecords/getVitalUnitOptionTemplate',
			updateCCMVitalEntry: 'ccmVitalEntry/updateCCMVitalEntry',
		}),
		closeDrawer () {
			this.timeSpentSeconds = 0;
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
		},

		updateVitalEntry () {
			const request = {
				id: this.selectedVitalEntry.id,
				body: {
					hospitalId: this.selectedVitalEntry.hospitalId,
					vitalDate: this.selectedVitalEntry.vitalDate,
					vitalType: this.selectedVitalEntry.vitalType,
					value: this.vitalValue,
					unit: this.selectedUnit,
					notes: this.notes,
					performedBy: this.selectedVitalEntry.performedBy,
					performedByRole: this.selectedVitalEntry.performedByRole,
					staffId: this.selectedVitalEntry.staffId,
					timeSpentSeconds: this.timeSpentSeconds,
					isRPMBillable: false,
					additionalData: this.selectedVitalEntry.additionalData,
				},
			};
			this.updateCCMVitalEntry(request);
			this.closeDrawer();
		},
	},
	// async mounted () {
	// 	this.notes = this.selectedVitalEntry.notes;
	// 	this.vitalValue = this.selectedVitalEntry.value;
	// 	this.selectedUnit = this.selectedVitalEntry.unit;
	// 	this.selectedType = this.selectedVitalEntry.vitalType;
	// 	const unitOptions = await this.getAllVitalUnitOptions();
	// 	this.availableUnits = unitOptions.data.filter(
	// 		(unit) => unit.vitalType === this.selectedType,
	// 	);
	// },

	watch: {
		selectedVitalEntry: {
			async handler () {
				this.notes = this.selectedVitalEntry.notes;
				const stringParts = this.selectedVitalEntry.value.split(' / ')[0];
				this.vitalValue = stringParts.split(' ')[0];

				this.selectedType = this.selectedVitalEntry.vitalType;
				if (!this.unitOptions) {
					this.unitOptions = await this.getAllVitalUnitOptions();
				}
				this.availableUnits = this.unitOptions.data.filter((unit) => unit.vitalType === this.selectedType);
				this.selectedUnit = stringParts.substring(stringParts.indexOf(' ') + 1);
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>
